import React from 'react';

import ComponentLoader from '../componentLoader/componentLoader';

import './loadingScreen.scss';

const LoadingScreen: React.FC = () => {
  return (
    <div className='loading-screen-wrapper'>
      <ComponentLoader />
    </div>
  );
};

export default LoadingScreen;
